"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsCustomizationProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var BackendContext_1 = require("../../react/BackendContext");
var WorkspaceContext_1 = require("../../react/WorkspaceContext");
var Context_1 = require("./Context");
var workspaceSettingsLoader_1 = require("./workspaceSettingsLoader");
var utils_1 = require("./utils");
var defaultTranslationsParam = {};
/**
 * This provider is here because of the need for customization of translations.
 * If you need to change translations based on some setting flag,
 * use this provider at the top of you your react tree.
 *
 * You can see that the provider accepts render function and customize function as parameters.
 * Using these two function you can customize your translations.
 *
 * @beta
 */
exports.TranslationsCustomizationProvider = function (_a) {
    var render = _a.render, _b = _a.customize, customize = _b === void 0 ? utils_1.pickCorrectWording : _b, _c = _a.translations, translationsParam = _c === void 0 ? defaultTranslationsParam : _c, backendParam = _a.backend, workspaceParam = _a.workspace;
    var backend = BackendContext_1.useBackend(backendParam);
    var workspace = WorkspaceContext_1.useWorkspace(workspaceParam);
    var _d = tslib_1.__read(react_1.useState(function () { return customize(translationsParam); }), 2), translations = _d[0], setTranslations = _d[1];
    var _e = tslib_1.__read(react_1.useState(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    react_1.useEffect(function () {
        var fetchSettings = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var loader, settings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!backend || !workspace) {
                            return [2 /*return*/];
                        }
                        setIsLoading(true);
                        loader = workspaceSettingsLoader_1.getWorkspaceSettingsLoader();
                        return [4 /*yield*/, loader.load(backend, workspace)];
                    case 1:
                        settings = _a.sent();
                        /**
                         * Because of issues described in the ticket FET-855, we decided to use this workaround.
                         * After the issues that are described in the ticket are solved or at least reduced,
                         * this workaround can be removed.
                         */
                        window.gdSettings = settings;
                        setTranslations(customize(translationsParam, settings));
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchSettings();
    }, [backend, workspace, translationsParam]);
    return (react_1.default.createElement(Context_1.TranslationsCustomizationContextProvider, { translationsCustomizationIsLoading: isLoading, translations: translations }, render(translations)));
};
//# sourceMappingURL=TranslationsCustomizationProvider.js.map